module.exports = __webpack_public_path__ + "img/course-box-title.57744b52.png";